

































































































































































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';

import { default as PageDescribe } from '@/components/PageDescribe.vue';
import { default as DataPanel } from '@/components/DataPanel.vue';
import { default as SearchPanel } from '@/components/SearchPanel.vue';
import { PaginationPanel , DraggerImg } from '@/components';
import collapse from '../../utils/collapse.js';
import publicFunc from '../../common/util/publicFunc';
import { Project, ProjectManager } from '@/http';
import { type } from '@/http/interface';
import { enums } from '@/common/enums';
import ListFilterPanel from '@/components/ListFilterPanel.vue';

export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: {
        PageDescribe,
        DataPanel,
        PaginationPanel,
        collapse,
        ListFilterPanel,
        SearchPanel,
        DraggerImg,
    },
})
export default class projectManager extends Vue {
    // 自适应表格列宽
    flexColumnWidth(str, tableData, flag = 'max') {
        // str为该列的字段名(传字符串);tableData为该表格的数据源(传变量);
        // flag为可选值，可不传该参数,传参时可选'max'或'equal',默认为'max'
        // flag为'max'则设置列宽适配该列中最长的内容,flag为'equal'则设置列宽适配该列中第一行内容的长度。
        str = str + '';
        let columnContent = '';
        if (!tableData || !tableData.length || tableData.length === 0 || tableData === undefined) {
            return '140px';
        }
        if (!str || !str.length || str.length === 0 || str === undefined) {
            return;
        }
        if (flag === 'equal') {
            // 获取该列中第一个不为空的数据(内容)
            for (let i = 0; i < tableData.length; i++) {
                if (tableData[i][str].length > 0) {
                    // console.log('该列数据[0]:', tableData[0][str])
                    columnContent = tableData[i][str];
                    break;
                }
            }
        } else {
            // 获取该列中最长的数据(内容)
            let index = 0;
            for (let i = 0; i < tableData.length; i++) {
                if (tableData[i][str] === null) {
                    return;
                }
                const now_temp = tableData[i][str] + '';
                const max_temp = tableData[index][str] + '';
                if (now_temp.length > max_temp.length) {
                    index = i;
                }
            }
            columnContent = tableData[index][str];
        }
        // console.log('该列数据[i]:', columnContent)
        // 以下分配的单位长度可根据实际需求进行调整
        let flexWidth = 0;
        for (const char of columnContent) {
            if ((char >= 'A' && char <= 'Z') || (char >= 'a' && char <= 'z')) {
                // 如果是英文字符，为字符分配8个单位宽度
                flexWidth += 9;
            } else if (char >= '\u4e00' && char <= '\u9fa5') {
                // 如果是中文字符，为字符分配15个单位宽度
                flexWidth += 16;
            } else {
                // 其他种类字符，为字符分配8个单位宽度
                flexWidth += 9;
            }
        }
        if (flexWidth < 160) {
            // 设置最小宽度
            flexWidth = 160;
        }
        // if (flexWidth > 250) {
        //   // 设置最大宽度
        //   flexWidth = 250
        // }
        return flexWidth + 10 + 'px';
    }
    public isDisabled: boolean = false;
    public publicFunc: any = publicFunc;
    public projectStatusType = enums.projectStatusType;
    public labelPosition: string = 'right';

    public expandType: boolean = false;
    public loading = false;
    public rePagin = false;
    public tabelData = [];
    public total = 0;
    public isActive: boolean = false;
    timeList = [];
    public datetimerange(value) {
        if (value) {
            this.searchValue.startTime = value[0];
            this.searchValue.endTime = value[1];
        } else {
            this.searchValue.startTime = null;
            this.searchValue.endTime = null;
        }
    }
     

    projectStatusArr: any = [];
    public searchValue: any = {
        projectCode: '',
        projectName: '',
        contractNumber: '',
        // consigneeCompany:'',
        // startTime: '',
        // endTime: '',
        // arrivalAddress: '',
        // code: '',
        // projectWay: '',
        // statusListStr: '',
        // winner: '',
        orderBy: '',
        projectStatus: '',
    };
    public tableData: any = [];
    public searchPagin: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public $refs: {
        pagination: HTMLFormElement;
        multipleTable: HTMLFormElement;
        // draggerImg:HTMLFormElement
        
    };

    //根据权限判断按钮显隐
    public dbb3: boolean = false;
    public dbz3: boolean = false;
    public dbs3: boolean = false;
    public dbbl3: boolean = false;
    public created() {
        let webMenus = JSON.parse(localStorage.getItem('mlssloginAd')).webMenus;
        // let webMenus = sessionStorage.getItem('webMenus') ? sessionStorage.getItem('webMenus') : localStorage.getItem('webMenus');
        this.dbb3 = webMenus.includes('dbb3');
        this.dbz3 = webMenus.includes('dbz3');
        this.dbs3 = webMenus.includes('dbs3');
        this.dbbl3 = webMenus.includes('dbbl3');
        

    }
    // disabledImg = false
    // public imgdrager(){     
    //      let that = this
    //         var box1 = document.getElementById("img1");
    //         box1.onmousedown = function (event) {         
    //             console.log(1);
    //             /*再次点击时使得图标任然在那个位置，鼠标可以点击到图标上*/
    //             var ol = event.clientX - box1.offsetLeft;
    //             var ot = event.clientY - box1.offsetTop;
    //             /*鼠标点击*/
    //             document.onmousemove = function (event) {
    //                 that.disabledImg = true
    //                 console.log(1);
    //                 var left = event.clientX - ol;
    //                 var top = event.clientY - ot;
    //                 box1.style.left = left+"px";/*赋值*/
    //                 box1.style.top = top+"px";
    //             }
    //             /*鼠标松开*/
    //             document.onmouseup = function (event) {
    //                 that.disabledImg = false
    //                 document.onmousemove = null;
    //                 document.onmouseup = null;
    //             }
    //              return false
    //         }
           
        
    // }
    public mounted() {
        // 图片拖拽
    //   this.imgdrager()
        // this.$refs.draggerImg.imgdrager()
        if (sessionStorage.getItem('projectManager_searchValue')) {
            this.searchValue = JSON.parse(sessionStorage.getItem('projectManager_searchValue'));
            this.timeList = [this.searchValue.startTime, this.searchValue.endTime];
            this.projectStatusArr = sessionStorage.getItem('projectManager_statusArr')
                ? JSON.parse(sessionStorage.getItem('projectManager_statusArr'))
                : [];

            this.searchPagin = sessionStorage.getItem('projectManager_page')
                ? JSON.parse(sessionStorage.getItem('projectManager_page'))
                : this.searchPagin;
            this.getProjectList();
        } else {
            this.searchPagin = sessionStorage.getItem('projectManager_page')
                ? JSON.parse(sessionStorage.getItem('projectManager_page'))
                : this.searchPagin;
            this.getProjectList();
        }
        this.isActive = sessionStorage.getItem('projectManager_isActive') ? JSON.parse(sessionStorage.getItem('projectManager_isActive')) : false;
    }

    public sort(col): void {
        console.log(col, 'aaaaaaaaaaa');
        if (col.order == 'ascending') {
            this.searchValue.asc = true;
        } else {
            this.searchValue.asc = false;
        }
        switch (col.prop) {
            case 'projectCode':
                {
                    this.searchValue.orderBy = '1';
                }
                break;
            case 'projectName':
                {
                    this.searchValue.orderBy = '2';
                }
                break;
            case 'creationTime':
                {
                    this.searchValue.orderBy = '3';
                }
                break;
        }
        this.getProjectList();
    }

    // public toEdit(data) {
    //     sessionStorage.setItem('projectManager_isActive', JSON.stringify(this.isActive));
    //     this.$router.push({
    //         path: '/AddProject',
    //         query: {
    //             id: data.id,
    //             type: 'edit',
    //         },
    //     });
    // }

    public getMore() {
        this.expandType = !this.expandType;
    }
    // 报表导出
    public async exportExcel() {
        this.searchValue.projectStatus = this.projectStatusArr.join();
        let data = await ProjectManager.ExportProject({
            ...this.searchValue,
            skip: this.searchPagin.skip,
            count: this.searchPagin.count,
        });
        // if (data && data.attachmentUrl) {
        //     window.open(data.attachmentUrl);
        // } else {
        //     this.$message.warning('导出失败!');
        // }
    }

    public getProjectList() {
        this.loading = true;
        this.searchValue.projectStatus = this.projectStatusArr.join();
        ProjectManager.GetList({
            ...this.searchValue,
            skip: this.searchPagin.skip,
            count: this.searchPagin.count,
        })
            .then((res) => {
                console.log(res.data, 'res');
                this.tableData = res.data;
                let skip = this.searchPagin.skip;
                this.tableData.map((item, index) => {
                    item.index = skip++ + 1;
                });
                this.total = res.total;
                this.loading = false;
                this.$refs.pagination.setNowPage(this.searchPagin.count);
                this.$refs.pagination.setPage(this.searchPagin.currentPage);
            })
            .catch((err) => {
                this.loading = false;
            });
    }
    public searchFunc() {
        sessionStorage.setItem('projectManager_searchValue', JSON.stringify(this.searchValue));
        sessionStorage.setItem('projectManager_statusArr', JSON.stringify(this.projectStatusArr));
        this.$refs.pagination.handleCurrentChange(1);
        this.searchPagin.skip = 0;
    }

    public async onPaginationChange(pagin: Pagination) {
        this.searchPagin = pagin;
        sessionStorage.setItem('projectManager_page', JSON.stringify(pagin));
        this.getProjectList();
    }

    // public viewProject(item) {
    //     sessionStorage.setItem('projectManager_page', JSON.stringify(this.searchPagin));
    //     sessionStorage.setItem('projectManager_isActive', JSON.stringify(this.isActive));
    //     this.$router.push({
    //         path: '/ProjectDetail',
    //         query: {
    //             type: 'view',
    //             id: item.id,
    //         },
    //     });
    // }
    public selectionRow = [] as any;
    public multipleSelection: any;
    public toOrderId = '';
    public toInquiryId = '';
    handleSelectionChange(rows) {
        this.selectionRow = rows;
        if (rows.length > 1) {
            this.$refs.multipleTable.clearSelection();
            this.$refs.multipleTable.toggleRowSelection(rows.pop());
        }
        if (rows.length != 0) {
            this.toOrderId = rows[rows.length - 1].id;
            this.toInquiryId = rows[rows.length - 1].id;
            if (rows[0].projectStatusStr == '待执行' || rows[0].projectStatusStr == '执行中') {
                this.isDisabled = false;
            } else {
                this.isDisabled = true;
            }
        }
    }
    @Watch('selectionRow')
    selectionRowCHange() {
        if (this.selectionRow.length == 0) {
            this.isDisabled = false;
        }
    }

    // public toOrderPage() {
    //     if (this.selectionRow.length == 1) {
    //         this.$router.push({
    //             path: '/addOrder',
    //             query: {
    //                 projectId: this.toOrderId,
    //                 type: 'project',
    //             },
    //         });
    //     } else {
    //         this.$message.warning('请选择一条招标成功的数据!');
    //     }
    // }
    /** 单选配置 */
    /* start */
    rowClick(row) {
        let refsElTable = this.$refs.multipleTable as any; // 获取表格对象
        let findRow = this.selectionRow.find((c) => c.rowIndex == row.rowIndex);
        if (findRow) {
            refsElTable.toggleRowSelection(row, false);
            return;
        }
        refsElTable.clearSelection();
        refsElTable.toggleRowSelection(row); // 调用选中行方法
    }

    rowStyle({ row, rowIndex }) {
        Object.defineProperty(row, 'rowIndex', {
            //给每一行添加不可枚举属性rowIndex来标识当前行
            value: rowIndex,
            writable: true,
            enumerable: false,
        });
    }
    selectable(row, rowIndex) {
        //多选框不可勾选
        if (this.selectionRow.find((c) => c.rowIndex === row.rowIndex)) {
            return true;
        } else {
            return false;
        }
    }
    toDetail(row, type) {
        sessionStorage.setItem('projectManager_isActive', JSON.stringify(this.isActive));
        if (type == 1) {
            this.$router.push({
                path: '/ProjectDetail',
                query: {
                    id: row.id,
                    name: 'detail',
                },
            });
        } else if (type == 2) {
            this.$router.push({
                path: '/ProjectDetail',
                query: {
                    id: row.id,
                    name: 'banli',
                },
            });
        }
    }
    copAdd() {
        sessionStorage.setItem('projectManager_isActive', JSON.stringify(this.isActive));
        if (this.selectionRow.length != 0) {
            this.$router.push({
                path: '/addProject',
                query: {
                    type: 'copy',
                    id: this.selectionRow[0].id,
                },
            });
        } else {
            this.$router.push({
                path: '/addProject',
                query: {
                    type:'xmxz'
                },
            });
        }
    }
    // 发货计划
    projectPlan() {
        if (this.selectionRow.length != 0) {
            if (this.selectionRow[0].projectStatusStr == '待执行' || this.selectionRow[0].projectStatusStr == '执行中') {
                this.$router.push({
                    query: {
                        projectplanid: this.toOrderId,
                        type: 'projectplan',
                    },
                    path: '/addOrder',
                });
            }
        } else {
            this.$message.warning('请选择待执行或者执行中的数据');
        }
    }
    // 询价
    projectInquiry() {
        if (this.selectionRow.length != 0) {
            if (this.selectionRow[0].projectStatusStr == '待执行' || this.selectionRow[0].projectStatusStr == '执行中') {
                this.$router.push({
                    query: {
                        projectinquiryid: this.toInquiryId,
                        type: 'projectinquiry',
                    },
                    path: '/addInquiry',
                });
            }
        } else {
            this.$message.warning('请选择待执行或者执行中的数据');
        }
    }
    // 启动执行
    public executeId: string;
    public toexecute(id) {
        this.executeId = id;
        this.dialogConfig5 = {
            title: '该项目启动执行',
            show: true,
        };
    }
    // 项目完成
    public finishId: any;
    public tofinish(id) {
        this.finishId = id;
        this.dialogConfig4 = {
            title: '该项目已完成',
            show: true,
        };
        // this.$router.push({
        //     path: '/addOrder',
        //     query: {
        //         projectId: id,
        //         type: 'project',
        //     },
        // });
    }
    // 完成项目单
    public dialogConfig4 = {
        title: '',
        show: false,
    };
    // 删除项目单
    public dialogConfig2 = {
        title: '',
        show: false,
    };
    public dialogConfig3 = {
        title: '',
        show: false,
    };
    public dialogConfig5 = {
        title: '',
        show: false,
    };
    confirmClose2() {
        this.dialogConfig2 = {
            title: '',
            show: false,
        };
    }
    confirmClose3() {
        this.dialogConfig3 = {
            title: '',
            show: false,
        };
    }
    confirmClose4() {
        this.dialogConfig4 = {
            title: '',
            show: false,
        };
    }
    confirmClose5() {
        this.dialogConfig5 = {
            title: '',
            show: false,
        };
    }
    confirmOk2() {
        ProjectManager.DelProject(this.data1).then(() => {
            this.$message.success('项目单删除成功');
            this.getProjectList();
        });
        this.dialogConfig2 = {
            title: '',
            show: false,
        };
    }
    confirmOk4() {
        ProjectManager.finishProject(this.finishId).then(() => {
            this.$message.success('项目单完成');
            this.getProjectList();
        });
        this.dialogConfig4 = {
            title: '',
            show: false,
        };
    }
    confirmOk5() {
        ProjectManager.StartProject(this.executeId).then(() => {
            this.$message.success('项目已执行');
            this.getProjectList();
        });
        this.dialogConfig5 = {
            title: '',
            show: false,
        };
    }
    public data1: any = null;
    public handleDelete(data) {
        this.data1 = data;
        this.dialogConfig2 = {
            title: '删除项目单',
            show: true,
        };
        // this.$confirm('确认删除该项目单?', '项目单删除', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning',
        // })
        //     .then(() => {
        //         Project.DelProject(data).then(() => {
        //             this.$message.success('项目单删除成功');
        //             this.getProjectList();
        //         });
        //     })
        //     .catch(() => {});
    }
    confirmOk3() {
        ProjectManager.EndProject(this.data2).then(() => {
            this.$message.success('项目单终结成功');
            this.getProjectList();
        });
        this.dialogConfig3 = {
            title: '',
            show: false,
        };
    }
    public data2: any = null;
    public handleFinal(data) {
        this.data2 = data;
        this.dialogConfig3 = {
            title: '终结项目单',
            show: true,
        };
        // this.$confirm('确认终结该项目单?', '项目单终结', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning',
        // })
        //     .then(() => {
        //         Project.EndProject(data).then(() => {
        //             this.$message.success('项目单终结成功');
        //             this.getProjectList();
        //         });
        //     })
        //     .catch(() => {});
    }
    public handleEdit(data) {
        sessionStorage.setItem('projectManager_isActive', JSON.stringify(this.isActive));
        this.$router.push({
            path: '/addProject',
            query: {
                id: data.id,
                type: 'edit',
            },
        });
    }

    public handleCommand(command) {
        console.log(command, 'command');
        switch (command.command) {
            case 'edit':
                this.handleEdit(command.data);
                break;
            case 'delete':
                this.handleDelete(command.data);
                break;
            case 'final':
                this.handleFinal(command.data);
                break;
        }
    }

    beforeHandleCommand(data, command) {
        return {
            data: data,
            command: command,
        };
    }

    public colData = JSON.parse(localStorage.getItem('projectManager'))
        ? JSON.parse(localStorage.getItem('projectManager'))
        : [
              { title: '项目状态', isShow: true, disabled: false },
              { title: '项目编号', isShow: true, disabled: false },
              { title: '项目名称', isShow: true, disabled: false },
              { title: '合同编号', isShow: true, disabled: false },
              { title: '项目开始时间', isShow: true, disabled: false },
              { title: '项目结束时间', isShow: true, disabled: false },
              { title: '收货单位', isShow: true, disabled: false },
              { title: '收货地址', isShow: true, disabled: false },
              { title: '收货联系人', isShow: true, disabled: false },
              { title: '创建人', isShow: true, disabled: false },
              { title: '创建时间', isShow: true, disabled: false },
          ];
    public handleCheckedChange() {
        let newDate = this.colData.filter((item) => item.isShow == false);
        if (this.colData.length - newDate.length == 3) {
            this.$message.warning('至少选择3个');
            this.colData.forEach((item) => {
                if (item.isShow) {
                    item.disabled = true;
                }
            });
        } else {
            this.colData.forEach((item) => {
                item.disabled = false;
            });
        }
        localStorage.setItem('projectManager', JSON.stringify(this.colData));
    }

    public resetSearchValue() {
        this.searchValue = {
            projectCode: '',
            projectName: '',
            contractNumber: '',
            // consigneeCompany:'',
            // startTime: '',
            // endTime: '',
            // arrivalAddress: '',
            // code: '',
            // projectWay: '',
            // statusListStr: '',
            // winner: '',
            orderBy: '',
            projectStatus: '',
        };
        this.projectStatusArr = [];
        this.timeList = [];
        this.$refs.multipleTable.clearSort();
        this.$refs.pagination.resetSize();
        this.$refs.pagination.handleSizeChange(10);
        this.searchFunc();
    }
}
